import { t, useLocale } from '../lib/i18n.js';
import { useEffect, useState } from 'react';
import type { CountdownPublic } from '@listen-draw/shared';
import { serverNow } from '../lib/store.js';

/** サーバーの until に合わせて 3・2・1・GO! を表示する */
export function Countdown({
  countdown,
  compact,
}: {
  countdown: CountdownPublic;
  compact?: boolean;
}) {
  useLocale();
  const [label, setLabel] = useState(() => digitFor(countdown));
  useEffect(() => {
    const id = window.setInterval(() => setLabel(digitFor(countdown)), 50);
    return () => window.clearInterval(id);
  }, [countdown]);
  return (
    <div className={`count${compact ? ' count--compact' : ''}`} aria-live="polite">
      <span className="count__lbl">
        {countdown.label === '音声スタート'
          ? t('Listen', '音声スタート')
          : t('Get ready to answer', '描画スタート')}
      </span>
      <span key={label} className={`count__digit${label === 'GO!' ? ' count__digit--go' : ''}`}>
        {label}
      </span>
    </div>
  );
}

function digitFor(c: CountdownPublic): string {
  const remain = c.until - serverNow();
  if (remain <= 350) return 'GO!';
  return String(Math.ceil((remain - 350) / 1000));
}
